import { animate, inView } from "motion";

const initVideoScrollAnimation = () => {
    const videoElements = document.querySelectorAll(".full-width-media");

    if (!videoElements.length) return;

    videoElements.forEach((video) => {
        const videoWrapper = video.querySelector(".full-width-media__wrapper");
        const textWrapper = video.querySelector(".full-width-media__text-wrapper");
        if (!videoWrapper) return;

        const isDesktop = window.matchMedia("(min-width: 1024px)").matches;

        if (!isDesktop) {
            animate(videoWrapper, { scale: 1 }, { duration: 0 });
            if (textWrapper) {
                animate(textWrapper, { scale: 1, y: 0, opacity: 1 }, { duration: 0 });
            }
            return;
        }

        animate(videoWrapper, { scale: 0.5 }, { duration: 0 });
        if (textWrapper) {
            animate(textWrapper, { scale: 0.3, y: 20, opacity: 0 }, { duration: 0 });
        }

        inView(
            videoWrapper,
            () => {
                animate(
                    videoWrapper,
                    { scale: 1 },
                    {
                        duration: 1.5,
                        ease: [0.4, 0, 0.2, 1],
                    }
                );

                if (textWrapper) {
                    animate(
                        textWrapper,
                        {
                            scale: 1,
                            y: 0,
                            opacity: 1,
                        },
                        {
                            duration: 0.75,
                            delay: 0.75,
                            ease: [0.4, 0, 0.2, 1],
                        }
                    );
                }
            },
            {
                amount: "all",
            }
        );
    });
};

const initVideoPlayer = () => {
    const videoContainers = document.querySelectorAll(".full-width-media");

    if (!videoContainers.length) return;

    videoContainers.forEach((container) => {
        const video = container.querySelector(".full-width-media__video");
        const videoContent = container.querySelector(".full-width-media__content");

        if (!video) return;

        // Video click handler - toggles play/pause
        const handleVideoClick = (e) => {
            // Prevent the click on the <video> bubbling to the wrapper and double-toggling
            e.stopPropagation();
            if (video.paused) {
                video.play();
            } else {
                video.pause();
            }
        };

        // Add click to both video and content wrapper to ensure it works
        video.addEventListener("click", handleVideoClick);
        if (videoContent) {
            videoContent.addEventListener("click", handleVideoClick);
        }
    });
};

const handleResize = () => {
    initVideoScrollAnimation();
};

const init = () => {
    initVideoScrollAnimation();
    initVideoPlayer();
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
} else {
    init();
}

window.addEventListener("resize", handleResize);
